import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../../components/header/AdminHeader'
import useAdminUserStore from '../../stores/admin/userStore'
import useToastStore from '../../stores/toastStore'

import { DataGrid, GridEditInputCell } from '@mui/x-data-grid'
import { styled } from '@mui/material/styles' // Sử dụng styled từ MUI v5

const CustomDataGrid = styled(DataGrid)(({ theme }) => {
    const pastelColors = {
        aqua: '#a7e6e6',
        yellow: '#fff9b3',
        green: '#b9f6b9',
    }

    return {
        '& .aqua-header': {
            backgroundColor: pastelColors.aqua,
        },
        '& .aqua-cell': {
            backgroundColor: pastelColors.aqua,
        },
        '& .yellow-header': {
            backgroundColor: pastelColors.yellow,
        },
        '& .yellow-cell': {
            backgroundColor: pastelColors.yellow,
        },
        '& .green-header': {
            backgroundColor: pastelColors.green,
        },
        '& .green-cell': {
            backgroundColor: pastelColors.green,
        },
    }
})

export default function BasicEditingGrid() {
    const { fetchUsers, users } = useAdminUserStore()
    const [rows, setRows] = useState([])
    const { addToast, removeToast } = useToastStore()
    const params = {}

    useEffect(() => {
        fetchUsers(params)
    }, [fetchUsers])

    useEffect(() => {
        setRows(users)
    }, [users])

    const columnDefs = [
        {
            headerName: 'Email',
            field: 'email',
            width: 180,
            type: 'text',
            editable: false,
            headerClassName: 'aqua-header',
        },
        {
            headerName: 'Role',
            field: 'role',
            width: 60,
            type: 'text',
            editable: false,
            headerClassName: 'aqua-header',
        },
        {
            headerName: 'Link Offer',
            field: 'link_offer_steam',
            width: 140,
            type: 'link',
            editable: false,
            headerClassName: 'aqua-header',
            renderCell: (params) => (
              <Link href={params.value} target="_blank" rel="noopener">
                {params.value}
              </Link>
            ),
        },
        {
            headerName: 'Phone',
            field: 'phone',
            width: 120,
            type: 'text',
            editable: false,
            headerClassName: 'aqua-header',
        },
        {
            headerName: 'Bank',
            field: 'bank_name',
            width: 120,
            type: 'text',
            editable: false,
            headerClassName: 'aqua-header',
        },
        {
            headerName: 'Bank Account Name',
            field: 'bank_account_name',
            width: 140,
            type: 'text',
            editable: false,
            headerClassName: 'aqua-header',
        },
        {
            headerName: 'Bank Account Num',
            field: 'bank_account_num',
            width: 140,
            type: 'text',
            editable: false,
            headerClassName: 'aqua-header',
        },
    ]

    return (
        <div>
            <Header />
            <section className="tf-section-admin">
                <h2 class="tf-title-heading ct style-2 fs-30 mg-bt-10">Quản lý người dùng</h2>
                <h3 class="tf-title-heading ct style-2 mg-bt-10">{rows.length} users</h3>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-2 col-lg-2 col-md-12">
                        </div>
                        <div className="col-xl-8 col-lg-8 col-md-12">
                            <div style={{ height: 'auto', width: 'auto' }}>
                        <CustomDataGrid
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: 'updated_at', sort: 'desc' }],
                                },
                            }}
                            rows={rows}
                            columns={columnDefs}
                            hideFooterPagination={true}
                            editMode="row"
                            sx={{
                                borderColor: '#FFFFFF',
                                fontSize: 12,
                                fontWeight: 500,
                                '& .MuiDataGrid-cell': {
                                    color: 'white',
                                    borderRight: '1px solid #ccc', // Đường viền giữa các ô dữ liệu
                                },
                                '& .MuiDataGrid-columnHeader': {
                                    borderRight: '1px solid #ccc', // Đường viền dưới tiêu đề cột
                                },
                                '& .MuiDataGrid-columnHeaders': {
                                    borderBottom: '2px solid #ccc', // Đường viền dưới tiêu đề cột
                                },
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    fontWeight: 800,
                                },
                                '& .MuiInputBase-input': {
                                    fontSize: 12,
                                    color: '#14141f',
                                },
                                '.MuiDataGrid-row--editing .MuiDataGrid-cell': {
                                    fontSize: 12,
                                    color: '#14141f',
                                },
                                '.MuiDataGrid-footerContainer': {
                                    display: 'none',
                                }
                            }}
                        />
                    </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
